var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tree" }, [
    _c(
      "ul",
      { staticClass: "tree-main-node opened" },
      [
        _c(
          "draggable",
          {
            staticClass: "tree-node",
            attrs: {
              list: _vm.ItreeData,
              element: "li",
              options: _vm.options,
              move: _vm.handleMove,
              "data-id": _vm.rootId,
            },
            on: { start: _vm.handleStart, end: _vm.handleEnd },
          },
          _vm._l(_vm.ItreeData, function (node) {
            return _c("TreeNode", {
              key: node.id,
              attrs: {
                treeData: node,
                options: _vm.options,
                level: 0,
                icons: _vm.icons,
                sortHandler: _vm.handleNodeSort,
                moveHandler: _vm.handleNodeMove,
                clickHandler: _vm.onNodeClick,
                rightClickHandler: _vm.onNodeRightClick,
              },
            })
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }